import { createClient } from '@supabase/supabase-js';

// IMPORTANT: Replace these with your ACTUAL Supabase Project URL and Anon Key 
// from your project settings at https://app.supabase.com
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ymqdvoxylizlvhkzcohq.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InltcWR2b3h5bGl6bHZoa3pjb2hxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUyMzMyNTEsImV4cCI6MjA4MDgwOTI1MX0.GvRXWiufxbHfr4lQR7XcsXzdLpBUxqGwA-44_VM2m4Q';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Diagnostic helper
export const checkConnection = async () => {
  try {
    const { data, error } = await supabase.from('organizations').select('count').limit(1);
    if (error) throw error;
    return { connected: true };
  } catch (err) {
    return { connected: false, error: err.message };
  }
};